import flightPackCode from "@/config/flightPackCode";
import transportPackCode from "@/config/transportPackCode";

export type TransportType = "flight" | "train" | "unknown";

export const getTransportType = (code: string): TransportType => {
	if (flightPackCode.includes(code)) return "flight";
	if (transportPackCode.includes(code)) return "train";
	return "unknown";
};

export const hasChangedTransportType = (
	currentCode: string,
	newCode: string,
	transportationSelected: boolean
): boolean => {
	const currentType = getTransportType(currentCode);
	const newType = getTransportType(newCode);
	return transportationSelected && currentType !== newType;
};
